import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { QuestionService } from '../../services/question.service';
import { AdminQuestion, QuestionType, Answer } from '../../models/questions';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-question-forms-selector',
  templateUrl: './question-forms-selector.component.html',
  styles: [],
})
export class QuestionFormsComponent implements OnInit {
  @Input() question: AdminQuestion = {};
  @Input() isSurveyQuestion: boolean;
  @Input() isMandatoryQuestion: boolean;
  @Input() selectedCategoryId: number;
  @Output() onDeleteQuestion = new EventEmitter<AdminQuestion>();
  @Output() onCloneQuestion = new EventEmitter<AdminQuestion>();
  @Output() onRemoveQuestionFromSurvey = new EventEmitter<{
    questionId: number;
    categoryId: number;
  }>();
  @Output() onQuestionMandatoryChange = new EventEmitter<{
    questionId: number;
    categoryId: number;
  }>();

  initialQuestion: AdminQuestion;
  isEdit = false;
  questionType: any = QuestionType;

  constructor(
    private questionService: QuestionService,
    private readonly toastr: ToastrService
  ) {}

  ngOnInit() {
    this.initialQuestion = { ...this.question };
  }

  getQuestionForEdit(id: number) {
    this.questionService.getOne(id).subscribe((q) => {
      this.question = q;
      this.isEdit = true;
    });
  }

  hideForm() {
    this.question = this.initialQuestion;
    this.isEdit = false;
  }

  closeOnSave(data: AdminQuestion) {
    this.getCatagoryQuestions(data);
  }

  getCatagoryQuestions(data: AdminQuestion) {
    this.questionService
      .getByCategoryId(this.selectedCategoryId)
      .subscribe((x) => {
        this.question = x.find((q) => q.id === data.id);
        this.isEdit = false;
      });
  }

  deleteQuestion(questionId) {
    this.questionService.delete(questionId).subscribe(
      (x) => {
        return this.onDeleteQuestion.emit(questionId);
      },
      (err: HttpErrorResponse) => {
        this.toastr.error(err.error, 'Error');
      }
    );
  }

  cloneQuestion(question: AdminQuestion) {
    this.questionService.getOne(question.id).subscribe((q) => {
      const questionClone = {
        ...Object.assign({
          answerType: q.answerType,
          localizedNames: q.localizedNames,
          answers: this.cloneAnswers(q.answers),
          categoryIds: q.categoryIds,
        } as AdminQuestion),
      };
      this.questionService
        .create(questionClone)
        .subscribe((x) => this.onCloneQuestion.emit(question));
    });
  }

  removeQuestionFromSurvey(questionId: number) {
    this.onRemoveQuestionFromSurvey.emit({
      questionId: questionId,
      categoryId: this.selectedCategoryId,
    });
  }

  changeQuestionMandatory(questionId: number) {
    this.onQuestionMandatoryChange.emit({
      questionId: questionId,
      categoryId: this.selectedCategoryId,
    });
  }

  private cloneAnswers(questionAnswers: Array<Answer>): Array<Answer> {
    return questionAnswers.map((a) =>
      Object.assign({
        localizedNames: a.localizedNames,
        name: a.name,
        order: a.order,
        compositeAnswerPortion: a.compositeAnswerPortion,
      } as Answer)
    );
  }
}
